// Generated from api/openapi/operations.yaml by make docs. Do not edit.
import { z } from "zod";

export const auditPaginationSchema = z.object({
  "total": z.number().int().min(0),
  "offset": z.number().int().min(0),
  "limit": z.number().int().min(0)
});

export const tenantAuditEventSchema = z.object({
  "id": z.string().uuid(),
  "tenant_id": z.string().uuid().nullable(),
  "actor_id": z.string().uuid().nullable(),
  "actor_email": z.string().nullable(),
  "actor_name": z.string().nullable(),
  "actor_role": z.string().nullable(),
  "event": z.string(),
  "result": z.enum(["success", "failure", "denied"]),
  "target_type": z.string().nullable(),
  "target_id": z.string().uuid().nullable(),
  "resource_name": z.string().optional(),
  "description": z.string(),
  "ip_address": z.string().nullable(),
  "user_agent": z.string().nullable(),
  "request_id": z.string().uuid().nullable(),
  "session_id": z.string().uuid().nullable(),
  "metadata": z.record(z.string(), z.unknown()),
  "created_at": z.string().datetime({ offset: true }),
  "device_id": z.string().uuid().optional(),
  "device_type": z.string().optional(),
  "geo_country": z.string().optional(),
  "organization_id": z.string().uuid().optional()
});

export const auditListResponseSchema = z.object({
  "data": z.array(tenantAuditEventSchema),
  "pagination": auditPaginationSchema
});

export const platformAuditEventSchema = z.object({
  "id": z.string().uuid(),
  "actor_id": z.string().uuid().nullable(),
  "actor_email": z.string().nullable(),
  "actor_name": z.string().nullable(),
  "actor_role": z.string().nullable(),
  "event": z.string(),
  "result": z.enum(["success", "failure", "denied"]),
  "target_type": z.string().nullable(),
  "target_id": z.string().uuid().nullable(),
  "resource_name": z.string().optional(),
  "description": z.string(),
  "ip_address": z.string().nullable(),
  "user_agent": z.string().nullable(),
  "request_id": z.string().uuid().nullable(),
  "session_id": z.string().uuid().nullable(),
  "metadata": z.record(z.string(), z.unknown()),
  "created_at": z.string().datetime({ offset: true }),
  "target_tenant_id": z.string().uuid().nullable(),
  "target_tenant_name": z.string().optional()
});

export const platformAuditListResponseSchema = z.object({
  "data": z.array(platformAuditEventSchema),
  "pagination": auditPaginationSchema
});

export const auditVerifyResultSchema = z.object({
  "id": z.string().uuid(),
  "valid": z.boolean(),
  "key_id": z.number().int(),
  "algorithm": z.string().optional(),
  "reason": z.string().optional(),
  "verified_at": z.string().datetime({ offset: true })
});

export const windowsAuthenticationSchema = z.object({
  "id": z.string().uuid(),
  "origin": z.enum(["witnessed", "reported"]),
  "outcome": z.enum(["success", "failure"]),
  "failure_reason": z.string().optional(),
  "tenant_id": z.string().uuid(),
  "user_id": z.string().uuid().optional(),
  "user_display_name": z.string().optional(),
  "user_primary_email": z.string().optional(),
  "attempted_identifier": z.string().optional(),
  "workstation_id": z.string().uuid(),
  "hostname_reported": z.string().optional(),
  "jkt": z.string(),
  "workstation_status": z.string(),
  "certificate_serial": z.string().optional(),
  "correlation_id": z.string().uuid().optional(),
  "reported_occurred_at": z.string().datetime({ offset: true }).optional(),
  "observed_at": z.string().datetime({ offset: true })
});

export const windowsAuthenticationsResponseSchema = z.object({
  "data": z.array(windowsAuthenticationSchema),
  "pagination": auditPaginationSchema
});
